export default __webpack_public_path__ + "static/NanoRaffle-a40eb58042beaad5e7a69937f1c2b8c2.png";